import { Fade } from "./Reveal";
import { LeadNum, Tags } from "./Bits";
import { EXPERTISE } from "../data";

export function Expertise() {
  return (
    <section id="expertise">
      <LeadNum no="02" label="Expertise" right="what I do" />
      <div>
        {EXPERTISE.map((e) => (
          <div className="exp-item" key={e.t}>
            <Fade className="exp-h">{e.t}</Fade>
            <div>
              <Fade className="exp-d">{e.d}</Fade>
              <Tags items={e.tech} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
